<template>
<div :class="['micad_formElement micad_formElement_progressBar',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <div class="micad_formElement_control_progressBar">
            <div class="micad_formElement_control_progressBar_bar" :style="{width: compleation + '%'}"></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Progress bar',
  data() {
    return {
        label: "Quisque tristique.",
        compleation: 30,
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_formElement_'+type
            }
        }
    }
};
</script>
